import { render, staticRenderFns } from "./CollectionReceipt.vue?vue&type=template&id=2d432101"
import script from "./CollectionReceipt.vue?vue&type=script&lang=js"
export * from "./CollectionReceipt.vue?vue&type=script&lang=js"
import style0 from "./CollectionReceipt.vue?vue&type=style&index=0&id=2d432101&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports